<template>
  <div ref="echart01" style="width:100%; height:200px;"></div>
</template>

<script>
export default {
  mounted() {
    let chart01 = this.$echarts.init(this.$refs.echart01)
    let xdata = ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23', '24', '25', '26', '27', '28', '29', '30']
    let ydata1 = [2000, 1800, 2800, 900, 1600, 2000, 3000, 2030, 1356, 1900, 4000, 3000, 2000, 3000, 4200, 3200, 3800, 2000, 1800, 2800, 900, 1600, 2000, 3000, 2030, 1356, 1900, 4000, 3000,3000]
    
    let option = {
      //   backgroundColor: "#FFF",
      grid: {
        top: '9%',
        bottom: '19%',
        left: '6%',
        right: '4%'
      },
      legend: {
        top: 0
      },
      tooltip: {
        trigger: 'axis',
        label: {
          show: true
        }
      },
      xAxis: {
        boundaryGap: true, //默认，坐标轴留白策略
        axisLine: {
          show: false
        },
        splitLine: {
          show: true,
          lineStyle: {
            type: 'dashed',
            color: 'rgba(33,148,246,0.2)'
          }
        },
        axisTick: {
          show: false,
          alignWithLabel: true
        },
        data: xdata
      },
      yAxis: {
        axisLine: {
          show: false
        },
        splitLine: {
          show: false
        },
        axisTick: {
          show: false
        },
        splitArea: {
          show: true,
          areaStyle: {
            color: 'rgb(245,250,254)'
          }
        }
      },
      series: [
        {
          name:'任务数',
          type: 'line',
          symbol: 'circle',
          symbolSize: 7,
          lineStyle: {
            color: 'rgb(71,233,231)',
            shadowBlur: 12,
            shadowColor: 'rgb(71,233,231,0.9)',
            shadowOffsetX: 1,
            shadowOffsetY: 1
          },
          itemStyle: {
            color: 'rgb(71,233,231)',
            borderWidth: 1,
            borderColor: '#fff'
          },
          label: {
            show: false,
            distance: 1,
          },
          data: ydata1
        }
      ]
    }
    chart01.setOption(option, true)
  }
}
</script>

<style></style>
